document.addEventListener('alpine:init', () => {
  Alpine.data('CorporateGifting', () => ({
    init() {
      this.InitSwipers();
    },
    e_ScrollTo(id) {
      const element = document.getElementById(id.replace('#', ''));
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      } 
      else {
        console.warn(`Element with id ${id} not found.`);
      }
    },
    InitSwipers() {
      this.InitReadyToShipSwiper();
    },
    InitReadyToShipSwiper() {
      let $section = document.querySelector('[data-rid="553bc524-34c6-4fcf-b3da-1206a4ea6879"]');
      let $swiper = document.querySelector('[data-replo-part="slides"]');
      if (!$swiper) return;

      $swiper.style = '';
      $swiper.classList.add('swiper', 'swiper--corporate-gifting');

      let $swiperWrapper = $swiper.querySelector('[data-replo-part="slide-track"]');
      $swiperWrapper.style = '';
      $swiperWrapper.classList.add('swiper-wrapper');

      $swiper.querySelectorAll('[data-replo-part="slide"]').forEach(slide => {
        slide.style = '';
        slide.classList.add('swiper-slide');
      });

      let swiper = new Swiper($swiper, {
        slidesPerView: 6,
        slidesPerGroup: 4,
        spaceBetween: 20,
        // loop: true,
        // centeredSlides: true,
        navigation: {
          nextEl: $section.querySelector('[data-direction="next"]'),
          prevEl: $section.querySelector('[data-direction="previous"]')
        },
        pagination: {
          el: $section.querySelector('[data-rid="d10a39c4-4874-4f91-a4ac-36cfb56cfce4"]'),
          clickable: true,
        },
      });

      // Add click event to product elements
      $swiper.querySelectorAll('[data-replo-product-handle]').forEach(product => {
        product.addEventListener('click', (e) => {
          e.preventDefault();
          const productHandle = product.getAttribute('data-replo-product-handle');
          if (productHandle) {
            window.location.href = `/products/${productHandle}`;
          } else {
            console.warn('Product handle not found for:', product);
          }
        });
      });
    }
   }));
});